// extracted by mini-css-extract-plugin
export default {"collapse":"ContractResponsiblesCollapse_collapse__uEBIw","icon":"ContractResponsiblesCollapse_icon__MEKnW"};